import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';
import { IoLogOutOutline } from "react-icons/io5";

const Navbar = () => {
  const username = localStorage.getItem('name');
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  useEffect(() => {
    const checkSession = () => {
      const loginTime = localStorage.getItem('loginTime');
      if (loginTime && Date.now() - parseInt(loginTime) > 60 * 60 * 1000) {
        handleLogout();
      }
    };
    const interval = setInterval(checkSession, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <nav className="navbarrrr">
      <div className="navbar-contentsss">
        <div className="navbar-headerrr">Hira EMS..</div>
        <div className="navbar-welcome">
          {username ? `Welcome, ${username}!` : 'Welcome, Guest!'}
        </div>
      </div>

      <button className="logout-button" onClick={handleLogout} aria-label="Logout">
        <span className="logout-text">Logout</span>
        <IoLogOutOutline className="logout-icon" />
      </button>
    </nav>
  );
};

export default Navbar;